module.exports = __webpack_public_path__ + "static/media/de_train.10445a68.jpg";